import { ComponentFactory, FunctionalComponent, h } from 'preact';

import { preactConnectStore } from 'common/module/preact/connect-store';
import { PropertyLeadPhoneService } from 'desktop/module/property-lead-phone/service';
import { PropertyLeadPhoneStore } from 'desktop/module/property-lead-phone/store';
import { PropertyPhoneNumberTemplate } from 'desktop/module/property-phone-number/template';
import { PropertyPhoneNumberTemplatePropsInterface } from 'desktop/module/property-phone-number/template-props.interface';

const PropertyPhoneNumber: FunctionalComponent<
  PropertyPhoneNumberTemplatePropsInterface & {
    propertyId: string;
    template?: ComponentFactory<PropertyPhoneNumberTemplatePropsInterface>;
  }
> = ({ template: Template, propertyId, ...props }) =>
  Template ? <Template {...props} /> : <PropertyPhoneNumberTemplate {...props} />;

export const PropertyPhoneNumberComponent = preactConnectStore<
  PropertyLeadPhoneStore,
  Pick<PropertyPhoneNumberTemplatePropsInterface, 'isPhoneNumberVisible'>,
  Pick<PropertyPhoneNumberTemplatePropsInterface, 'phoneNumber' | 'placeholder'> & {
    propertyId: string;
    template?: ComponentFactory<PropertyPhoneNumberTemplatePropsInterface>;
  }
>(PropertyLeadPhoneService(), (store, { props }) => ({
  isPhoneNumberVisible: store.getState().visiblePhoneNumbers[props.propertyId],
}))(PropertyPhoneNumber);
